<template>
  <div class="cf-flex cf-flex--row cf-flex--align-center cf-flex--gap-16">
    <cf-text-input
      type="text"
      :label="label"
      :name="name"
      :prevent-input="true"
      :select-all-on-focus="true"
      :model-value="value"
    />

    <button
      v-if="nativeShareEnabled"
      class="cf-button cf-button--tertiary cf-button--fixed-32"
      type="button"
      @click="shareNatively"
    >
      <span class="cf-icon far fa-external-link" />
      <span class="ada-text">Copy to clipboard</span>
    </button>

    <button
      v-else
      :id="`${name }-button`"
      :data-clipboard-text="value"
      class="cf-button cf-button--tertiary cf-button--fixed-32"
      type="button"
    >
      <span class="cf-icon far fa-cut" />
      <span class="ada-text">Copy to clipboard</span>
    </button>
  </div>
</template>


<script>
  import Clipboard from 'clipboard';

  import errorHandlers from '@/services/error-handlers';
  import events from '@/services/events';

  import CfTextInput from '@/view/components/shared/cf-text-input/index.vue';


  export default {
    name: 'CfCopyToClipboard',

    components: {
      CfTextInput
    },

    props: {
      iconClass: {
        type: String,
        default: 'fa-link'
      },

      isUrl: {
        type: Boolean,
        default: true
      },

      label: {
        type: String,
        required: true
      },

      name: {
        type: String,
        required: true
      },

      value: {
        type: String,
        default: null
      }
    },

    data() {
      return {
        clipboard: null,
        nativeShareEnabled: false
      };
    },

    created() {
      this.createdHandler();
    },

    unmounted() {
      this.destroyedHandler();
    },

    mounted() {
      this.mountedHandler();
    },

    methods: {
      clipboardCopyError() {
        events.emit('notification', {
          type: 'error',
          message: 'Failed to copy to clipboard.'
        });
      },

      clipboardCopySuccess() {
        events.emit('notification', {
          type: 'success',
          message: 'Copied to clipboard!'
        });
      },

      createdHandler() {
        this.nativeShareEnabled = !!window.navigator.share;
      },

      destroyedHandler() {
        if (this.clipboard) {
          this.clipboard.destroy();
        }
      },

      mountedHandler() {
        if (!this.nativeShareEnabled) {
          this.clipboard = new Clipboard(`#${this.name}-button`);
          this.clipboard.on('error', this.clipboardCopyError);
          this.clipboard.on('success', this.clipboardCopySuccess);
        }
      },

      async shareNatively() {
        try {
          const details = {};

          if (this.isUrl) {
            details.url = this.value;
          }
          else {
            details.text = this.value;
          }

          await window.navigator.share(details);
        }

        catch (error) {
          errorHandlers.silent(error);
        }
      }
    }
  };
</script>
